import React from 'react';
import PropTypes from 'prop-types';
import { getUrl, getDescText } from '../../common/services/builders';

function ListingCard({ entry }) {
    return (
        <div className="column large-4">
            <article className="ui-card" style={{minHeight: 460 + 'px'}}>
                <div className="ui-card__image">
                    <div className="ui-card__image-container" style={renderImage(entry)}></div>
                </div>
                <div className="ui-card__content  text-center">
                    <h3 className="ui-card__heading"><a href={getUrl(entry)}>{entry.projectTitle}</a></h3>
                    <p className="ui-card__text">{getDescText(entry)}</p>
                    {/* <div className="ui-card__tags">
                        {renderTags(entry)}
                    </div> */}
                </div>
            </article>
        </div>
    );

}
function renderImage(entry){
    let styles = {};
    if(entry.heroImage != null && entry.heroImage != ''){
        styles = {backgroundImage: `url(https://www.twi-global.com${entry.heroImage.asset.sys.uri}?height=300&width=500)`};
    }
    else{
        styles = {backgroundImage: `url(https://www.twi-global.com/CachedImage.axd?ImageName=/site-elements/images/hero/hero-slider-1.jpg&ImageHeight=300&ImageWidth=500)`};
    }
    return styles;
}
function renderTags(entry) {
    // if(entry && entry.industries){
    //     if(!Array.isArray(entry.industries)){
    //         return <span className="tag">{entry.industries.name}</span>;
    //     }
    //     else{
    //         return entry.industries.map((e, index) => <span key={index} className="tag">{e.name}</span>);
    //     }
    // }
    // else{
    //     return <span className="tag">All</span>;
    // }

    if(entry && entry.status){

        if (entry.status == 'Proposal')
        {
            return (
                <span className='tag'>Proposal</span>
            );
                
            
        }

        if (entry.status == 'Project')
        {
            return <span className='tag'>Project</span>;
        }

        if (entry.status == 'Completed')
        {
            return <span className='tag'>Completed</span>;
        }


        return <span className='tag'>{entry.status}</span>;
    
    }
}

ListingCard.propTypes = {
    entry: PropTypes.object,
};

export default ListingCard;